import React from 'react';
import { createRoot } from 'react-dom/client';
import { BaseQuoteToolLauncher } from '@PetSureAustralia/petsure-quote-tool-base/distBaseQuoteTool/components/BaseQuoteTool/BaseQuoteToolWrapper';

import { QuoteToolConfigs } from '../quoteToolConfigs';
import { BrandMetaTags } from '../../../components/BrandMetaTags';
import { initSentry } from '../../../helpers/initSentry';
import { AdFixusScriptTags } from '../../../components/AdFixusScriptTags';

export const BupaPublicQuoteTool = () => (
  <>
    <AdFixusScriptTags {...QuoteToolConfigs.public.tool?.brandConfig?.theme} />
    <BrandMetaTags {...QuoteToolConfigs.public.meta} />
    <BaseQuoteToolLauncher {...QuoteToolConfigs.public.tool} />
  </>
);

initSentry({ brand: 'bupa' });
const rootElement = document.getElementById('app');
const root = createRoot(rootElement);

root.render(<BupaPublicQuoteTool />);
